export default __webpack_public_path__ + "static/media/check.00dc9687.svg";